import React from 'react';
import { AppBar, Typography } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};
const AppBarHeader = (props) => {
    return (
        <AppBar position="static" color="default" sx={appBarStyle}> 
            <Typography
                variant="h4"
                flexGrow={1}
                fontSize={15}
                fontWeight={700}
                fontFamily={'Lato'}
                noWrap
                fontStyle="normal"
                color='primary'
                component="div"
                sx={{
                    ml: 1,
                }}
            > {props.icon ? (
                props.icon == 'takeoff' ? (
                    <FlightTakeoffIcon color="primary" />
                ) : (
                    <FlightLandIcon color="primary" />
                )
            ) : null} &nbsp; {props.title}
                &nbsp;&nbsp;{props.showTranportText && (<Typography variant="caption">
                    (This person will be responsible for releasing drivers at the end of the night; otherwise, they will be charged for the use of the vehicle.)
                </Typography>)}
            </Typography>
            
            {/* <Title
                title={props.title}
                addicon={props.icon}
                sx={{
                    ml: 1,
                }}
            /> */}
        </AppBar>
    );
};
export default AppBarHeader;
